import hasElementConflict from './has-element-conflict';
import hasWiderBreakpointValue from './has-wider-breakpoint-value';
import isPlainValue from './is-plain-value';

export default {
  hasElementConflict,
  hasWiderBreakpointValue,
  isPlainValue,
};
